import React from 'react'

export default props => <svg
  width="13"
  height="13"
  viewBox="0 0 13 13"
  fill="none"
  {...props}
>
  <rect x="0.5" y="0.5" width="12" height="12" rx="6" stroke="#4F4F4F"/>
  <rect x="0.5" y="0.5" width="4" height="4" rx="2" transform="translate(4 4)" fill="#4F4F4F" stroke="#4F4F4F"/>
</svg>



// WEBPACK FOOTER //
// ./src/modules/RadioControl/RadioIconSvg.js